
import React from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import { CreatePartnershipForm } from './CreatePartnershipForm';
import { AdminProtectedRoute } from '../Core/Routes/AdminProtectedRoute';
import { CreateAgentForm } from './CreateAgentForm';
import AdminContext from './AdminContext';
import { Agencies } from './Agencies';
import { AssignAgentForm } from './AssignAgentForm';
import {Reports} from '../PolicyManagement/Reports'
import {SendBorderaux} from '../PolicyManagement/SendBorderaux'

export const AdminRoutes = () => {
    const { path, url } = useRouteMatch();

    return (
        <Switch>
                <AdminContext>

                    <AdminProtectedRoute path={`${path}/reports`} component={Reports}/>

                    <AdminProtectedRoute path={`${path}/borderaux`} component={SendBorderaux}/>

                    <AdminProtectedRoute path={`${path}/agencies`} component={Agencies} />

                    <AdminProtectedRoute path={`${path}/createAgency`} component={CreatePartnershipForm} />

                    <AdminProtectedRoute path={`${path}/createAgent`} component={CreateAgentForm} />

                    <AdminProtectedRoute path={`${path}/assignAgent`} component={AssignAgentForm} />
                    

                </AdminContext>

                <Redirect exact from={`${path}`} to={`${path}/agencies`} />
            
        </Switch>)
}